__turbopack_context__.v({
  "label": "Label-module__hQuoVq__label",
});
